"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const calculateLocalOrerUtil_1 = require("./calculateLocalOrerUtil");
const precisionMath_1 = require("./precisionMath");
const round_1 = __importStar(require("./round"));
function calculateSurchargeModifier(order, surchargeModifier) {
    // 每次重算先清空上次結果，避免沿用舊值
    (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, item => {
        item.surcharge = 0;
    });
    if (lodash_1.default.isObject(order.surchargeTax)) {
        order.surchargeTax.tax = 0;
        order.surchargeTax.taxableTotal = 0;
    }
    if (surchargeModifier == null) {
        return;
    }
    // 第一次accumulate，計算 surchargeBase
    let surchargeBase = 0;
    (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, item => {
        var _a, _b;
        if (surchargeModifier.overrideItem || !item.excludedOrderSurcharge) {
            const totalForSurcharge = order.isSurchargeBasedOnDiscountedItemTotal === true
                ? ((_a = item.totalAfterDiscount) !== null && _a !== void 0 ? _a : 0)
                : ((_b = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _b !== void 0 ? _b : 0);
            surchargeBase = (0, precisionMath_1.add)(surchargeBase, totalForSurcharge);
        }
    });
    // 做第二次accumulate，同時計算每個 item 的服務費, 因為要用上次算好的 surchargeBase
    let calculatedAmountAcc = 0;
    const calculateItemSurcharge = (item) => {
        var _a, _b;
        if (surchargeModifier.overrideItem || !item.excludedOrderSurcharge) {
            const totalForSurcharge = order.isSurchargeBasedOnDiscountedItemTotal === true
                ? ((_a = item.totalAfterDiscount) !== null && _a !== void 0 ? _a : 0)
                : ((_b = item.totalWithoutSetItemsWithoutDiscountModifiers) !== null && _b !== void 0 ? _b : 0);
            if (surchargeModifier.percent !== 0) {
                // 百分比服務費，直接計算
                const percentageSurcharge = (0, precisionMath_1.multiply)(totalForSurcharge, surchargeModifier.percent / 100);
                item.surcharge = (0, precisionMath_1.add)(item.surcharge, percentageSurcharge);
            }
            if (surchargeModifier.amount !== 0 && surchargeBase > 0) {
                // 固定數值的服務費，需要依比例分攤到各個 item
                const distributedAmount = (0, precisionMath_1.multiply)(surchargeModifier.amount, (0, precisionMath_1.divide)(totalForSurcharge, surchargeBase));
                item.surcharge = (0, precisionMath_1.add)(item.surcharge, distributedAmount);
            }
        }
        calculatedAmountAcc = (0, precisionMath_1.add)(calculatedAmountAcc, item.surcharge);
    };
    (0, calculateLocalOrerUtil_1.forEachValidBatchItem)(order.batches, calculateItemSurcharge);
    // 服務費不可 < 0
    calculatedAmountAcc = Math.max(0, calculatedAmountAcc);
    if (order.enableIntermediateRounding) {
        calculatedAmountAcc = (0, round_1.default)(calculatedAmountAcc, order.rounding.type, order.rounding.digits);
    }
    // 計算服務費稅金
    if (lodash_1.default.isObject(order.surchargeTax)) {
        const surchargeBeforeTax = order.surchargeTax.isTaxInclusive
            ? (0, precisionMath_1.divide)(calculatedAmountAcc, 1 + order.surchargeTax.percent / 100)
            : calculatedAmountAcc;
        const taxRate = order.surchargeTax.percent / 100;
        order.surchargeTax.tax = (0, round_1.roundByCurrency)(order, (0, precisionMath_1.multiply)(surchargeBeforeTax, taxRate));
        order.surchargeTax.taxableTotal = surchargeBeforeTax;
    }
    return {
        modifier: Object.assign(Object.assign({}, surchargeModifier), { calculatedAmount: calculatedAmountAcc }),
    };
}
exports.default = calculateSurchargeModifier;
//# sourceMappingURL=calculateOrderSurcharge.js.map